import { Controller } from "@hotwired/stimulus";

// Cycles the verb in the home hero's headline ("...qui met en action / simplifie / connecte...
// tous vos projets de développement territorial"), fading it out, swapping the word, then fading
// it back in — same behaviour as the reference mockup's <TitreDynamique>.
export default class extends Controller {
  static targets = ["verb"];
  static values = {
    verbs: Array,
    interval: { type: Number, default: 2400 },
  };

  connect() {
    this.index = 0;
    this.timeoutId = null;
    this.intervalId = setInterval(() => this.cycle(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  }

  cycle() {
    if (!this.hasVerbTarget || this.verbsValue.length < 2) return;

    this.verbTarget.classList.add("opacity-0");
    this.timeoutId = setTimeout(() => {
      this.index = (this.index + 1) % this.verbsValue.length;
      this.verbTarget.textContent = this.verbsValue[this.index];
      this.verbTarget.classList.remove("opacity-0");
    }, 300);
  }
}
